import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import { DELIVERY_COLOUR, DEMAND_COLOUR } from 'utils/colours';

export const initialMonetisationHealthToggleState: Toggle[] = [
  {
    filter: 'demand',
    value: 'Demand Rate',
    active: true,
    color: DEMAND_COLOUR,
  },
  {
    filter: 'delivery',
    value: 'Delivery Rate',
    active: true,
    color: DELIVERY_COLOUR,
  },
];
